import React from "react";
import styled from "styled-components";

const MANIESTO = styled.article`
  flex: 1;
  overflow: auto;
  padding-bottom: 1em;
  scroll-behavior: smooth;
  .description > .title {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 32em;
    h1 {
      flex: 1;
      margin: 0;
      > a {
        color: inherit;
        text-decoration: none;
        &:hover, &:focus {
          text-decoration: underline;
        }
      }
    }
  }
  .description {
    max-width: 32em;
    position: relative;
    h1 {
      text-transform: uppercase;
      font-size: 1.75em;
      line-height: 1;
    }
    z-index: 4;
    padding: 1em;
    background: var(--main-bg-alpha);
    backdrop-filter: blur(3px);
    margin: auto;
    border-radius: 1em;
  }
`

function Manifesto() {
  return (
    <MANIESTO>
      <div className="description">
      <h1>Newsletter</h1>
        <p>
          The <b>Pessimists' Archive</b> newsletter gives you a weekly roundup of new
          and old finds shared on our social accounts. Each clipping has a
          little more context and information than on social media.
        </p>
      </div>
      <div>
        <iframe
          src="https://pessimistsarchive.substack.com/embed"
          width="360"
          height="320"
          frameborder="0"
          scrolling="no"
        ></iframe>
      </div>
    </MANIESTO>
  );
}

export default Manifesto;
